import { useParams } from 'react-router';

type ListDetailsPageParams = {
	id: string;
};

export const useListsDetailsParams = () => {
	const { id } = useParams<ListDetailsPageParams>();

	return { listId: id };
};
